import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9b60ca40"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["width", "height"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28ZM21.6 8.6C21.6 8.48954 21.5105 8.4 21.4 8.4H6.6C6.48954 8.4 6.4 8.48954 6.4 8.6V9.92184L13.5588 13.9487C13.8328 14.1028 14.1673 14.1028 14.4412 13.9487L21.6 9.92186V8.6ZM6.4 19.4V11.5281L12.8724 15.1689C13.5726 15.5627 14.4275 15.5627 15.1276 15.1689L21.6 11.5281V19.4C21.6 19.5105 21.5105 19.6 21.4 19.6H6.6C6.48954 19.6 6.4 19.5105 6.4 19.4ZM6.6 7C5.71634 7 5 7.71635 5 8.6V19.4C5 20.2837 5.71634 21 6.6 21H21.4C22.2837 21 23 20.2837 23 19.4V8.6C23 7.71634 22.2837 7 21.4 7H6.6Z"
}, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    class: "icon-email",
    width: _ctx.px,
    height: _ctx.px,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _hoisted_3, 8, _hoisted_1))
}